module.exports = __webpack_public_path__ + "static/media/blue-background-modern.63a7d32e.svg";